export default class CartMessage extends HTMLElement {
    freeLimit;
    leftToSpend;
    progress;

    constructor() {
        super();
        
        debug('CartMessage');
    }
    
    connectedCallback() {
        this.setupEventListeners();
        
        this.freeLimit = Number(this.dataset.limit) * 100;
        this.leftToSpend = this.querySelector('[data-left-to-spend]');
        this.progress = this.querySelector('progress');
    }
    
    disconnectedCallback() {}

    setupEventListeners() {        
        document.addEventListener('ajaxProduct:added', (event) => this.getCartUpdate());
        
        document.addEventListener('cart:upsellAdded', (event) => this.getCartUpdate());
            
        document.addEventListener('cart:updated', (event) => {   
          let subtotal = event.detail.cart.items_subtotal_price;       
          this.updateMessage(subtotal);
        });    
    }
    
    getCartUpdate() {
      fetch(theme.routes.cart, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        })
          .then((response) => {
            response.json().then((cart) => {
              let subtotal = cart.items_subtotal_price;
              this.updateMessage(subtotal);
            });
          })
          .catch((error) => {
            console.error(error);
          });    
    }
    
    updateMessage(subtotal) {        
        const newPercentValue = (subtotal / this.freeLimit) * 100;
        const leftToSpend = String(theme.Currency.formatMoney(this.freeLimit - subtotal, theme.settings.moneyFormat)).replace('.00', '');
        
        this.classList.toggle('is-hidden', subtotal == 0);            
        this.classList.toggle('is-success', subtotal >= this.freeLimit);
    
        this.progress.classList.toggle('is-hidden', (subtotal / this.freeLimit) >= 1);
        this.progress.setAttribute('value', newPercentValue);
        
        this.leftToSpend.innerHTML = leftToSpend;     
        
        debug('CartMessage updateMessage', newPercentValue, leftToSpend);          
    }    
}